export default {
  actions: {
    getAppSettings(context) {
      return new Promise((resolve, reject) => {
        this.dispatch('appsettings/find',{
          query:{}
        }).then((response)=>{
          if(response.data){
            context.commit('setCurrent', response.data[0])
            resolve(response.data[0])
          } else {
            resolve()
          }
        }).catch((error)=>{
          console.log(error)
        })
      })
    }
  }
}